import { BaseService, Status, DataResponse } from './base.service';

export interface CSVTranslation {
  id: string;
  field: string;
  value_nl: string;
  value_en: string;
}

export interface Validation {
  index: number;
  field: string;
}

class TranslationsService extends BaseService {
  private url: string = '/api/translation';

  constructor() {
    super();
  }

  public async update(
    csv: File,
  ): Promise<
    DataResponse<{ faultyLines: Validation[]; updates: CSVTranslation[] }>
  > {
    const data = new FormData();
    data.append('file', csv);

    const res = await this.$http.post<{
      faultyLines: Validation[];
      updates: CSVTranslation[];
    }>(`${this.url}`, data, true);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }
}

export default new TranslationsService();
